import React from 'react';
type SectionHeadingProps = {
  eyebrow?: string;
  title: string;
  subtitle?: string;
  align?: 'left' | 'center';
  tone?: 'cream' | 'forest';
};
export function SectionHeading({
  eyebrow,
  title,
  subtitle,
  align = 'left',
  tone = 'cream'
}: SectionHeadingProps) {
  const isForest = tone === 'forest';
  return <div className={`max-w-2xl ${align === 'center' ? 'mx-auto text-center' : ''}`} data-id="element-109" data-mp="3k18ag6cofsjo">
      {eyebrow && <p className={`text-xs uppercase tracking-widest2 ${isForest ? 'text-forest/60' : 'text-cream-muted'}`} data-id="element-110" data-mp="bkvhgqbgskvz">
          {eyebrow}
        </p>}
      <h2 className={`mt-4 font-display text-3xl font-semibold leading-tight tracking-tight sm:text-4xl ${isForest ? 'text-forest' : 'text-cream'}`} data-id="element-111" data-mp="1u0vzo61lpbl">
        {title}
      </h2>
      {subtitle && <p className={`mt-4 text-base ${isForest ? 'text-forest/70' : 'text-cream-dim'}`} data-id="element-112" data-mp="z9xypx26sbpy">
          {subtitle}
        </p>}
    </div>;
}